import React from "react";
import styled from "styled-components/native";
import getPlatformType from "../helpers/getPlatform";

const layoutType = getPlatformType();
let Container;
let CenterPanal;
let ListView, Main;

if (layoutType == "phone") {
  ListView = styled.View`
    width: 343px;
    height: 226px;
    background-color: white;
    margin: 5px 0px 5px 0px;
    border-bottom-left-radius: 20;
    border-top-right-radius: 20px;
    box-shadow: 1px 1px #d0cfd0;
  `;
  Container = styled.View`
    justify-content: center;
    align-items: center;
  `;
  Main = styled.View`
    background-color: #fafafa;
  `;
} else if (layoutType == "web") {
  ListView = styled.View`
    width: 364px;
    height: 226px;
    background-color: white;
    margin: 10px 10px 10px 10px;
    border-bottom-left-radius: 20;
    border-top-right-radius: 20px;
    box-shadow: 1px 1px #d0cfd0;
  `;
  Container = styled.View`
    margin: 16px 16px;
    flex-direction: row;
    justify-content: center;
  `;
  Main = styled.View`
    flex: 1;
    background-color: #fafafa;
  `;
} else {
  ListView = styled.View`
    width: 304px;
    height: 226px;
    background-color: white;
    margin: 15px 10px 10px 15px;
    border-bottom-left-radius: 20;
    border-top-right-radius: 20px;
    box-shadow: 1px 1px #d0cfd0;
  `;
  Container = styled.View`
    margin: 16px 16px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
  `;
  Main = styled.View`
    flex: 1;
    background-color: #fafafa;
  `;
}
const LeftPanal = styled.View`
  width: 60px;
  background-color: green;
  margin-right: 6px;
`;
const RightPanal = styled.View`
  width: 459px;
  background-color: pink;
  margin-left: 6px;
`;
const Section1 = styled.View`
  width: 100%;
  height: 55%;
`;
const Section2 = styled.View`
  width: 100%;
  height: 45%;
`;

export {
  CenterPanal,
  LeftPanal,
  RightPanal,
  Container,
  ListView,
  Section1,
  Section2,
  Main,
};
